<template>
    <div>
        <div class="dropzone" v-bind="getRootProps()" v-if="!loading">
            <input type="file" @input="handleUpload()" formenctype="multipart/form-data"
                v-bind="getInputProps({ multiple: false })" />
            <div class="dropzone-content">
                <slot v-if="!isDragActive"></slot>
            <slot v-if="isDragActive" name="dragActive"></slot>
            </div>
            <slot v-if="errorMessage" name="error">
                <div v-if="errorMessage" class="text-primary">{{ errorMessage }}</div>
            </slot>

        </div>
    </div>
</template>
<script setup>
import { watch, reactive, defineProps, defineEmits, onUnmounted, ref } from 'vue';
import { useDropzone } from 'vue3-dropzone';

const props = defineProps({

    layout: {
        type: String,
        default: undefined,
    },
    acceptedTypes: {
        type: String,
        default: undefined,
    },
    // Bytes; a larger file is refused here instead of by the API on save.
    maxSize: {
        type: Number,
        default: undefined,
    },

    type: {
        type: String,
        default: undefined,
    },

    loading: {
        type: Boolean,
        default: undefined,
    },
    index: {
        type: Number,
        default: undefined,
    },
    parentData: {
        type: Object,
        default: undefined,
    },

});

const errorMessage = ref('');

let emit = defineEmits(['accepedtTypes'])
const data = reactive({
    files: new Set(),
});
const allData = ref()

let filesWithPreview = []
const rejectionMessage = (rejections) => {
    const codes = rejections?.[0]?.errors?.map((error) => error.code) ?? [];
    if (codes.includes('file-too-large') && !codes.includes('file-invalid-type')) {
        return `Dit bestand is te groot (max. ${props.maxSize / 1024 / 1024} MB).`;
    }
    const types = props.acceptedTypes.split(',').map((type) => type.trim().split('/').pop().toUpperCase());
    return `Dit bestandstype wordt niet ondersteund. Toegestaan: ${types.join(', ')}.`;
};

const onDrop = (acceptFiles, rejections) => {
    if (acceptFiles.length > 0 && props.acceptedTypes.includes(acceptFiles[0].type) || acceptFiles.length > 0 && props.acceptedTypes.length == 0) {
        // Only an accepted file reaches the parent: an empty list would clear its
        // image and hide this dropzone, error and all.
        emit('acceptFiles', acceptFiles);
        allData.value = acceptFiles
   
        emit('currentType', acceptFiles[0].type);

        data.value = acceptFiles;
        const uniqueFiles = acceptFiles.filter(file => !data.files.has(file.path));
        filesWithPreview = uniqueFiles.map(file => ({ ...file, preview: URL.createObjectURL(file) }));
        data.files = new Set([...data.files, ...filesWithPreview]);
        emit('previews', filesWithPreview)
        errorMessage.value = null
} else {
        allData.value = null
        errorMessage.value = rejectionMessage(rejections);
    }
};

const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: props.acceptedTypes,
    maxSize: props.maxSize,
});

const handleUpload = () => {
    // emit('file-upload', e);
    // state.files.push(e);
};


const handleDeleteFiles = () => {
    data.files.forEach(file => URL.revokeObjectURL(file.preview));
    data.files.clear();

    emit('previews', []);
};

watch(() => props.parentData, (newVal) => {
    data.files = new Set(newVal)
    // console.log('Files data changed:', newVal);

});


onUnmounted(() => {
    handleDeleteFiles();

    data.files.forEach(file => URL.revokeObjectURL(file.preview));
});
</script>